import * as Sentry from '@sentry/electron/renderer'
import { GlobalState } from '@highlight/ipc'
import {
  isStaticChannel,
  sentryEnvironmentForChannel,
  sentryReleaseVersion,
  StaticBuildChannel,
} from '@highlight/common'
import {
  getCurrentVersion,
  getInstalledChannel,
  getReportingChannelAtStartup,
} from '@shared/utils/builds/channels.shared'

const isEnabled = process.env.NODE_ENV !== 'development'

function getSentryReleaseVersion(): string {
  return `highlight@${sentryReleaseVersion(getCurrentVersion(), getInstalledChannel())}`
}

export const initSentryRenderer = () => {
  if (!isEnabled) {
    return
  }

  if (!GlobalState.isReady()) {
    GlobalState.whenReady().then(() => initSentryRenderer())
    return
  }
  const installedChannel = getInstalledChannel()
  const reportingChannel = getReportingChannelAtStartup()
  const isDynamic = !isStaticChannel(installedChannel)
  const isAlpha = installedChannel === StaticBuildChannel.alpha
  const isBeta = reportingChannel === StaticBuildChannel.beta
  const isAlphaOrBeta = isAlpha || isBeta || isDynamic
  Sentry.init({
    release: getSentryReleaseVersion(),
    environment: sentryEnvironmentForChannel(reportingChannel),
    anrDetection: isAlphaOrBeta ? { captureStackTrace: true, anrThreshold: 15000, pollInterval: 500 } : false,
  })
  Sentry.setTag('release.channel', reportingChannel)
  Sentry.setTag('release.installed_channel', installedChannel)
}
